// src/contexts/SettingsContext.jsx
import React, { createContext, useContext, useState, useEffect } from 'react';
import { getAllSettings } from '../services/settings-service';

const SettingsContext = createContext({
  settings: null,
  reload: () => {},
});

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);

  const reload = async () => {
    try {
      const dto = await getAllSettings();
      setSettings(dto);
    } catch (err) {
      console.error('Failed to load settings', err);
    }
  };

  useEffect(() => {
    reload();
  }, []);

  return (
    <SettingsContext.Provider value={{ settings, reload }}>
      {children}
    </SettingsContext.Provider>
  );
};

// custom hook for convenience
export const useSettings = () => useContext(SettingsContext);
